import { render, staticRenderFns } from "./EntitiesCrud.vue?vue&type=template&id=20000104&"
import script from "./EntitiesCrud.vue?vue&type=script&lang=js&"
export * from "./EntitiesCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports